export default __webpack_public_path__ + "static/media/nearby.992e0bc9.mp4";